import React, { useState, useEffect, useRef } from "react";
import httpos from "../../../helpers/httpos";
import { toast } from "react-toastify";
import { DEFAULT_EXPORT_MAX_PROPERTIES } from "./propertySelection";
import "react-toastify/dist/ReactToastify.css";
import { doObjToFormData } from "../../../helpers/helpers";
import FormProcessingSpinner from "../../common/FormProcessingSpinner";
import { toggleResultView } from "../../../states/actions/resultView";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SaveSearchPopup from "./saveSearchPopup";
import { Tooltip as ReactTooltip } from "react-tooltip";
import DeleteLabel from "./deleteLabel";
import SearchLabelsBlk from "./searchLabelsBlk";
import {
  addLabelToPropertiesInBatches,
  bulkLabelSummary,
  findLabelNamed,
  normalizeLabelName,
} from "./labelMenu";
import BulkSelectionControl from "./BulkSelectionControl";
import useHeightCssVar from "../../../hooks/useHeightCssVar";

const ResultFilters = (props) => {
  const dispatch = useDispatch();
  const [showNewLabelInput, setShowNewLabelInput] = useState(false);
  const [addLabelToProperties, setAddLabelToProperties] = useState(false);
  const [editLabel, setEditLAbel] = useState({ show: false, item: null });
  // labelName/labelColor belong to the edit popup. The "New label +" input has
  // its own pair: when they were shared, opening a label to edit put its name
  // in the new-label box too, and that box's Save made another copy of it.
  const [labelName, setLabelName] = useState("");
  const [propertyLabel, setPropertyLabel] = useState("");
  const [labelColor, setLabelColor] = useState("#000000");
  const [newLabelName, setNewLabelName] = useState("");
  const [newLabelColor, setNewLabelColor] = useState("#000000");
  // "create" | "update" | "assign" while a label write is in flight.
  const [labelBusy, setLabelBusy] = useState(null);
  const labelBusyRef = useRef(false);
  const { ToggleHideSearch, hideSearch, ownertoggle, showowners } = props;
  const sortValue = props?.sortValue;
  const selectedPropertyTitles = props?.selectedPropertyTitles;
  const selectedPropertyParcelIDs = props?.selectedPropertyParcelIDs;
  const exportMaxProperties = props?.exportMaxProperties || DEFAULT_EXPORT_MAX_PROPERTIES;
  const selectedPropertyIds = props?.selectedPropertyIds;
  const newAddedPropertyLabels = props?.newAddedPropertyLabels;
  const setNewAddedPropertyLabels = props?.setNewAddedPropertyLabels;
  const setSortValue = props?.setSortValue;
  const [sort, setSort] = useState(false);
  const [label, setLabel] = useState(false);
  const [labels, setLabels] = useState([]);
  const [userLabels, setUserLabels] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const resultView = useSelector((state) => state.resultView.resultView);
  const handleChangeEditLabel = (e, item) => {
    if (e.target.name === "label_name") {
      setLabelName(e.target.value);
    }
    if (e.target.name === "label_color") {
      setLabelColor(e.target.value);
    }
  };
  const handleChangePropertyLabel = (e, item) => {
    setPropertyLabel(e.target.value);
  };
  const handleCloseEditLabel = (e) => {
    e.preventDefault();
    setLabelName("");
    setLabelColor("#000000");
    setEditLAbel({ show: false, item: null });
  };
  const handleShowEditLabel = (e, item) => {
    e.preventDefault();
    setLabelName(item?.label_name);
    setLabelColor(item?.label_color);
    setEditLAbel({ show: true, item: item });
  };
  const popupRef2 = useRef();
  // The toolbar wraps onto more rows when its buttons don't fit on one line;
  // the results list and map are offset by this measured height.
  useHeightCssVar(popupRef2, "--search-toolbar-height");
  const ToggleLabel = () => {
    setSort(false);
    setLabel(!label);
  };
  const ToggleOwners = () => {
    var owners = true;
    ownertoggle(owners);
    const sections = document.querySelectorAll(
      ".search_result_page.filter_show_after"
    );

    if (sections.length > 1) {
      for (let i = 0; i < sections.length; i++) {
        sections[i].style.display = "none";
      }
    }
  };
  const ToggleProperties = () => {
    ownertoggle(false);
    const sections = document.querySelectorAll(
      ".search_result_page.filter_show_after"
    );

    if (sections.length > 1) {
      for (let i = 1; i < sections.length; i++) {
        sections[i].style.display = "none";
      }
    }

    // show the first section
    if (sections.length > 0) {
      sections[0].style.display = "block";
    }
  };
  const ToggleSort = () => {
    setLabel(false);
    setSort(!sort);
  };
  const selectSortValue = (e, value) => {
    e.preventDefault();
    setSortValue(value);
    setLabel(false);
    setSort(!sort);
    props.handleSearchSortSubmit(e, value);
  };
  const showLabelInput = () => {
    setShowNewLabelInput(!showNewLabelInput);
  };

  const handleLabelNameChange = (e) => {
    setNewLabelName(e.target.value);
  };

  const handleLabelColorChange = (e) => {
    setNewLabelColor(e.target.value);
  };

  // One label write at a time. The ref is what stops a double click: both
  // clicks of a burst run before React re-renders the disabled button, so a
  // state flag alone still let one Save send four creates.
  const runLabelWrite = async (kind, write) => {
    if (labelBusyRef.current) return;
    labelBusyRef.current = true;
    setLabelBusy(kind);
    try {
      await write();
    } finally {
      labelBusyRef.current = false;
      setLabelBusy(null);
    }
  };

  const postLabel = () => {
    const name = normalizeLabelName(newLabelName);
    if (name === "") {
      toast.error("Please enter a label name.");
      return;
    }
    const existing = findLabelNamed(userLabels, name);
    if (existing) {
      toast.error(`A label named "${existing.label_name}" already exists.`);
      return;
    }

    runLabelWrite("create", () =>
      httpos
        .post("create-user-label-properties", {
          labelName: name,
          labelColor: newLabelColor || "#000000",
        })
        .then(({ data }) => {
          if (Number(data?.status) === 1) {
            toast.success(data.msg);
            setNewLabelName("");
            setNewLabelColor("#000000");
            setUserLabels(data?.labels || []);
          } else {
            toast.error(data?.msg || "Couldn't save the label. Please try again.");
          }
        })
        .catch(() => {
          toast.error("Couldn't save the label. Please try again.");
        })
    );
  };
  const updateLabel = (e, label_id) => {
    e.preventDefault();
    if (!label_id) {
      toast.error("Invalid label");
      return;
    }
    const name = normalizeLabelName(labelName);
    if (name === "") {
      toast.error("Please enter a label name.");
      return;
    }
    const existing = findLabelNamed(userLabels, name, label_id);
    if (existing) {
      toast.error(`A label named "${existing.label_name}" already exists.`);
      return;
    }

    runLabelWrite("update", () =>
      httpos
        .post("update-user-label-properties/" + label_id, {
          labelName: name,
          labelColor: labelColor || "#000000",
        })
        .then(({ data }) => {
          if (Number(data?.status) === 1) {
            toast.success(data.msg);
            const updated = data?.label || { label_name: name, label_color: labelColor };
            setUserLabels((labels) =>
              labels.map((label) =>
                label.id === label_id ? { ...label, ...updated, id: label.id } : label
              )
            );
            setEditLAbel({ show: false, item: null });
            setLabelName("");
            setLabelColor("#000000");
          } else {
            toast.error(data?.msg || "Couldn't update the label. Please try again.");
          }
        })
        .catch(() => {
          toast.error("Couldn't update the label. Please try again.");
        })
    );
  };
  // "Add label to selected properties" → Save. This used to post to a route the
  // backend never had, and the swallowed error made Save look dead.
  const addLabelsToProperties = (e) => {
    e.preventDefault();
    if (!(selectedPropertyIds?.length > 0)) {
      toast.error("please select a property first to continue!");
      return;
    }
    const label = userLabels.find((label) => label.id === propertyLabel);
    if (!label) {
      toast.error("please select label to continue!");
      return;
    }

    runLabelWrite("assign", async () => {
      const result = await addLabelToPropertiesInBatches(
        httpos,
        label.id,
        selectedPropertyIds
      );

      if (result.labelled > 0 || result.alreadyLabelled > 0) {
        setNewAddedPropertyLabels(result.propertyLabels);
        setAddLabelToProperties(false);
        setPropertyLabel("");
        setLabel(false);
      }

      if (result.error) {
        toast.error(
          result.labelled > 0
            ? `${bulkLabelSummary(label.label_name, result)} ${result.error}`
            : result.error
        );
      } else if (result.labelled > 0 || result.alreadyLabelled > 0) {
        toast.success(bulkLabelSummary(label.label_name, result));
      } else {
        toast.error(bulkLabelSummary(label.label_name, result) || "Couldn't add the label. Please try again.");
      }
    });
  };
  useEffect(() => {
    fetchUserLabels();
  }, []);
  const handleOutsideClick2 = (e) => {
    if (!popupRef2.current.contains(e.target)) {
      setLabel(false);
      setSort(false);
    }
  };

  const handleToggleResultView = (type) => {
    dispatch(toggleResultView(type));
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick2);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick2);
    };
  }, []);

  const fetchUserLabels = () => {
    httpos
      .post("get-user-label-properties", {label_type: "property"})
      .then(({ data }) => {
        setUserLabels(data.labels);
      })
      .catch((error) => {});
  };
  const renderLabels = () => {
    return labels.map((label, index) => (

<div className="_col_left">
                            <div
                              key={label.id + 12789100000000}
                              className={`label_btn ${label.label_color}`}
                              style={{ backgroundColor: label.color }}
                            >
                              <span>{label.name}</span>
                              {/* <span>(2)</span> */}
                            </div>
                            <div className="col_right_lbl">
                              <button
                                type="button"
                                onClick={(e) => handleShowEditLabel(e, label)}
                              >
                                <img src="/images/pencil.svg" alt="" />
                              </button>
                            </div>
                          </div>
    ));
  };
  const location = useLocation();
  const navigate = useNavigate();
  const handleExportList = () => {
    const uniqueParcelIds = Array.from(new Set(selectedPropertyParcelIDs || []));

    if (uniqueParcelIds.length > exportMaxProperties) {
      toast.error(`You can only export up to ${exportMaxProperties.toLocaleString()} properties at a time. You have selected ${uniqueParcelIds.length}.`);
      return;
    }

    if (uniqueParcelIds.length > 0) {
      sessionStorage.setItem(
        "pendingPropertyExportIds",
        JSON.stringify(uniqueParcelIds)
      );
      navigate(`/export`, { state: { parcel_ids: uniqueParcelIds } });
    } else {
      toast.error("please select properties to continue");
    }
  };

  // [EXPORTED TRACKING] Clears all exported property markers from localStorage
  const handleResetExportMarkers = () => {
    localStorage.removeItem("exportedPropertyIds");
    window.dispatchEvent(new Event("exportMarkersUpdated")); // Notify Result-properties to re-read
    toast.success("Export markers have been reset.");
  };

  const labelDrop = useRef();
  const sortByDrop = useRef();
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        !labelDrop?.current?.contains(e.target) &&
        !sortByDrop?.current?.contains(e.target)
      ) {
        setLabel(false);
        setSort(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, []);
  const truncateText = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };
  const [saveSearchPopup, setSaveSearchPopup] = useState(false);

  return (
    <>
      <div
        ref={popupRef2}
        className={hideSearch ? "result_filter less_top" : "result_filter"}
      >
        <div className="contain-fluid big_contain_fluid">
          <div className="filter_result_flex">
            <div className="_col">
              <div className="filter_blk">
                <button
                  disabled={showowners}
                  className={
                    showowners ? "site_btn" : "site_btn blank yellow_blank"
                  }
                  onClick={ToggleProperties}
                >
                  Properties
                </button>
                <div class="drop_filter drop_result_btn owner_filter_tbl">
                  <button
                    disabled={!showowners}
                    className={
                      showowners ? "site_btn blank yellow_blank" : "site_btn"
                    }
                    onClick={ToggleOwners}
                  >
                    Owners
                  </button>
                </div>
                {showowners && (
                  <BulkSelectionControl
                    onSelectPages={props.onBulkSelectPages}
                    isLoading={props.isBulkSelecting}
                    disabled={props.bulkSelectionDisabled}
                  />
                )}
                <div class="drop_filter drop_result_btn hide_main_filter_new_result_big">
                  <button
                    class="filter_btn site_btn blank yellow_blank no_filter"
                    onClick={ToggleLabel}
                  >
                    <span>Label</span>
                    <img src="/images/label_circle.svg" alt="" />
                  </button>
                  <div
                    className={
                      label ? "drop_cnt medium active" : "drop_cnt medium"
                    }
                  >
                    <SearchLabelsBlk
                      userLabels={userLabels}
                      handleShowEditLabel={handleShowEditLabel}
                      renderLabels={renderLabels}
                      addLabelToProperties={addLabelToProperties}
                      setAddLabelToProperties={setAddLabelToProperties}
                      selectedPropertyIds={selectedPropertyIds}
                      selectedPropertyTitles={selectedPropertyTitles}
                      handleChangePropertyLabel={handleChangePropertyLabel}
                      propertyLabel={propertyLabel}
                      addLabelsToProperties={addLabelsToProperties}
                      editLabel={editLabel}
                      handleCloseEditLabel={handleCloseEditLabel}
                      labelName={labelName}
                      handleChangeEditLabel={handleChangeEditLabel}
                      labelColor={labelColor}
                      setUserLabels={setUserLabels}
                      setEditLAbel={setEditLAbel}
                      updateLabel={updateLabel}
                      showLabelInput={showLabelInput}
                      showNewLabelInput={showNewLabelInput}
                      handleLabelNameChange={handleLabelNameChange}
                      handleLabelColorChange={handleLabelColorChange}
                      postLabel={postLabel}
                      newLabelName={newLabelName}
                      newLabelColor={newLabelColor}
                      labelBusy={labelBusy}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="_col">
              <div className="filter_blk">
                <div
                  class="drop_filter drop_result_btn hide_main_filter_new_result_small"
                  ref={labelDrop}
                >
                  <button
                    class="filter_btn site_btn blank yellow_blank no_filter"
                    onClick={ToggleLabel}
                  >
                    <span>Label</span>
                    <img src="/images/label_circle.svg" alt="" />
                  </button>
                  <div
                    className={
                      label ? "drop_cnt medium active" : "drop_cnt medium"
                    }
                  >
                    <SearchLabelsBlk
                      userLabels={userLabels}
                      handleShowEditLabel={handleShowEditLabel}
                      renderLabels={renderLabels}
                      addLabelToProperties={addLabelToProperties}
                      setAddLabelToProperties={setAddLabelToProperties}
                      selectedPropertyIds={selectedPropertyIds}
                      selectedPropertyTitles={selectedPropertyTitles}
                      handleChangePropertyLabel={handleChangePropertyLabel}
                      propertyLabel={propertyLabel}
                      addLabelsToProperties={addLabelsToProperties}
                      editLabel={editLabel}
                      handleCloseEditLabel={handleCloseEditLabel}
                      labelName={labelName}
                      handleChangeEditLabel={handleChangeEditLabel}
                      labelColor={labelColor}
                      setUserLabels={setUserLabels}
                      setEditLAbel={setEditLAbel}
                      updateLabel={updateLabel}
                      showLabelInput={showLabelInput}
                      showNewLabelInput={showNewLabelInput}
                      handleLabelNameChange={handleLabelNameChange}
                      handleLabelColorChange={handleLabelColorChange}
                      postLabel={postLabel}
                      newLabelName={newLabelName}
                      newLabelColor={newLabelColor}
                      labelBusy={labelBusy}
                    />
                  </div>
                </div>
                <button
                  className="site_btn yellow_blank blank"
                  onClick={handleExportList}
                  disabled={isExporting}
                >
                  <FormProcessingSpinner isFormProcessing={isExporting} />
                  Export List
                </button>
                {/* [EXPORTED TRACKING] Button to clear all exported property markers */}
                <button
                  className="site_btn yellow_blank blank"
                  onClick={handleResetExportMarkers}
                >
                  Reset Markers
                </button>
                <div
                  class="drop_filter drop_result_btn cell_top_high_mrgn"
                  ref={sortByDrop}
                >
                  <button
                    class="filter_btn site_btn blank yellow_blank no_filter"
                    onClick={ToggleSort}
                  >
                    <span>
                      Sort by:{" "}
                      {sortValue === "year"
                        ? "Year Built"
                        : sortValue === "owner_name"
                        ? "Owner Name"
                        :
                         sortValue === "lot_area"
                        ? "Lot Area"
                        : sortValue === "sale_price"
                        ? "Sale Price"
                        : sortValue === "property_type"
                        ? "Property Type"
                        : sortValue === "last_sale_date"
                        ? "Last Sale Date"
                        : sortValue === "tax_year"
                        ? "Tax Year"
                        : sortValue === "tax_amount"
                        ? "Tax Amount"
                        : sortValue === "property_sf"
                        ? "Property square footage"
                        : sortValue === "street_name"
                        ? "Street Name"
                        : ""}
                    </span>
                    <img src="/images/filter_circle.svg" alt="" />
                  </button>
                  <div
                    className={
                      sort
                        ? "drop_cnt height_cnt_drop_bdy exact_wide active"
                        : "drop_cnt height_cnt_drop_bdy exact_wide"
                    }
                  >
                    <div className="option_lst">
                      <button
                        onClick={(e) => selectSortValue(e, "property_type")}
                        className={sortValue == "property_type" ? "active" : ""}
                      >
                        Property Type
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "owner_name")}
                        className={sortValue == "owner_name" ? "active" : ""}
                      >
                        Owner Name
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "lot_area")}
                        className={sortValue == "lot_area" ? "active" : ""}
                      >
                        Lot Area
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "last_sale_date")}
                        className={
                          sortValue == "last_sale_date" ? "active" : ""
                        }
                      >
                        Last Sale Date
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "sale_price")}
                        className={sortValue == "sale_price" ? "active" : ""}
                      >
                        Sales Price
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "year")}
                        className={sortValue == "year" ? "active" : ""}
                      >
                        Year Built
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "tax_year")}
                        className={sortValue == "tax_year" ? "active" : ""}
                      >
                        Tax Year
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "tax_amount")}
                        className={sortValue == "tax_amount" ? "active" : ""}
                      >
                        Tax Amount
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "property_sf")}
                        className={sortValue == "property_sf" ? "active" : ""}
                      >
                        Property square footage
                      </button>
                      <button
                        onClick={(e) => selectSortValue(e, "street_name")}
                        className={sortValue == "street_name" ? "active" : ""}
                      >
                        Street Name
                      </button>
                    </div>
                  </div>
                </div>
                <button
                  class={
                    hideSearch
                      ? "filter_btn site_btn view_searches_btn"
                      : "after_filter_view filter_btn site_btn view_searches_btn"
                  }
                  onClick={ToggleHideSearch}
                >
                  <span>View Search</span>
                  <img src="/images/show_search_icon.svg" alt="" />
                </button>
                <button
                  className={`togg_icon_search cell_show_map ${
                    resultView == "list" && "active"
                  }`}
                  onClick={() => handleToggleResultView("list")}
                  disabled={resultView == "list"}
                  data-tooltip-id="table-view"
                >
                  <img src="/images/list-props.svg" alt="" />
                </button>
                <ReactTooltip
                  id="table-view"
                  place="bottom"
                  content="Table View"
                />
                <button
                  className={`togg_icon_search cell_show_map ${
                    resultView == "table" && "active"
                  }`}
                  onClick={() => handleToggleResultView("table")}
                  disabled={resultView == "table"}
                  data-tooltip-id="map-view"
                >
                  <img src="/images/map-props.svg" alt="" />
                </button>
                <ReactTooltip id="map-view" place="bottom" content="Map View" />
                <a
                  className="site_btn blank yellow_blank"
                  href="/search-property"
                >
                  Reset Search
                </a>
                <button
                  type="button"
                  className="filter_btn site_btn blank yellow_blank"
                  onClick={() => setSaveSearchPopup(true)}
                >
                  Save Search
                </button>
              </div>
            </div>
            
            
              <div className="_col fix_width_new">
                {showowners && (
                  <div className="filter_blk">
                    <button
                      type="button"
                      className={`togg_icon_search ${
                        resultView == "list" && "active"
                      }`}
                      onClick={() => handleToggleResultView("list")}
                      disabled={resultView == "list"}
                      data-tooltip-id="table-view"
                    >
                      <img src="/images/list-props.svg" alt="" />
                    </button>
                    <button
                      type="button"
                      className={`togg_icon_search ${
                        resultView == "table" && "active"
                      }`}
                      onClick={() => handleToggleResultView("table")}
                      disabled={resultView == "table"}
                      data-tooltip-id="map-view"
                    >
                      <img src="/images/map-props.svg" alt="" />
                    </button>
                  </div>
                )}
              </div>
            
          </div>
        </div>
      </div>
      {saveSearchPopup ? (
        <SaveSearchPopup setSaveSearchPopup={setSaveSearchPopup} />
      ) : (
        ""
      )}
    </>
  );
};

export default ResultFilters;
